import { ca } from '@cian/analytics';

/**
 * @description Событие: клик по слайду карусели в блоке Серия Плюс.
 */
export function trackSeriaPlusCarouselSlideClick(slideIndex: number): void {
  ca('eventSite', {
    action: 'click_seria_plus_carousel_slide',
    category: 'Promo',
    label: String(slideIndex + 1),
    name: 'oldevent',
    useLastProducts: true,
  });
}
